import React from 'react';
import PropTypes from 'prop-types';
import { InfoWrapper, Icon, Hide } from './styled';
import SvgIcon from '../svg-icon/svg-icon';
import {
  Step1,
  Step2,
  Step3,
  Step4,
  Step5
} from '../../helpers/icon-dictionary';

const TopicInfo = (props) => {
  const {
    standardName,
    ljName,
    externalKey,
    description,
    hideStrand,
    count,
    displayHideOption,
    subName
  } = props;
  let stepIcon = null;

  switch (count) {
    case 1:
      stepIcon = Step1;
      break;

    case 2:
      stepIcon = Step2;
      break;

    case 3:
      stepIcon = Step3;
      break;

    case 4:
      stepIcon = Step4;
      break;

    case 5:
      stepIcon = Step5;
      break;

    default:
      break;
  }

  return (
    <InfoWrapper count={count}>
      {displayHideOption && (
        <Hide onClick={() => true || hideStrand}>Hide</Hide>
      )}
      <div className="headerWrapper">
        <div className="title">
          <div className="standardName">{standardName}</div>
          <div className="subName">{subName}</div>
          <div className="subTitle">{externalKey}</div>
          {ljName && <div className="subTitle">{ljName}</div>}
        </div>
        {count ? (
          <Icon>
            <SvgIcon className="steps" icon={stepIcon} />
          </Icon>
        ) : null}
      </div>
      <div className="description">{description}</div>
    </InfoWrapper>
  );
};

TopicInfo.propTypes = {
  standardName: PropTypes.string,
  subName: PropTypes.string,
  ljName: PropTypes.string,
  externalKey: PropTypes.string,
  description: PropTypes.string,
  hideStrand: PropTypes.func,
  count: PropTypes.number,
  displayHideOption: PropTypes.bool
};

export default TopicInfo;



// WEBPACK FOOTER //
// ./components/topic-info/index.js